import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.Title',
    defaultMessage: 'Add Special Claim Record',
  },
  modalDescription: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.Description',
    defaultMessage:
      'Provide the approved Special Claim details below to create the claim on this voucher.',
  },
  cancel: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.Cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.Save',
    defaultMessage: 'Save',
  },
  claimTypeLabel: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.ClaimTypeLabel',
    defaultMessage: 'Claim Type',
  },
  claimTypePlaceholder: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.ClaimTypePlaceholder',
    defaultMessage: 'Select an option',
  },
  claimIdLabel: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.ClaimIdLabel',
    defaultMessage: 'Claim ID',
  },
  claimIdPlaceholder: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.ClaimIdPlaceholder',
    defaultMessage: 'Enter 14-character Claim ID',
  },
  claimIdTooltip: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.ClaimIdTooltip',
    defaultMessage:
      'Enter the Special Claim ID assigned by HUD when this claim was approved.',
  },
  claimIdError: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.ClaimIdError',
    defaultMessage: 'Claim ID must be exactly 14 alphanumeric characters.',
  },
  requestedAmountLabel: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.RequestedAmountLabel',
    defaultMessage: 'Amount Requested',
  },
  requestedAmountError: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.RequestedAmountError',
    defaultMessage: 'Requested Amount must be greater than 0.',
  },
  chargeCodeLabel: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.ChargeCodeLabel',
    defaultMessage: 'Charge Code',
  },
  chargeCodeTooltip: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.ChargeCodeTooltip',
    defaultMessage:
      'The selected charge code will be used when posting any applicable payment(s)' +
      ' after the HUD voucher has been approved.',
  },
  chargeCodePlaceholder: {
    id: 'App.ManageHudVoucherDetails.SpecialClaims.AddSpecialClaimModal.ChargeCodePlaceholder',
    defaultMessage: 'Charge Code',
  },
});
